import React from "react";

/**
 * PlacementConfirmedCard — "A candidate was just hired"
 *
 * Shows anonymized hire info: role + company. No candidate name.
 * No CTAs (the job is already filled).
 *
 * Props:
 *   card — feed card object with metadata containing:
 *     job_id, role_title, company_name
 */
const PlacementConfirmedCard = ({ card }) => {
  const meta = card.metadata || {};

  return (
    <div style={styles.card}>
      <div style={styles.row}>
        <div style={styles.iconWrap}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>

        <div style={styles.content}>
          <p style={styles.message}>
            A candidate was just hired
            {meta.role_title ? ` for a ${meta.role_title} role` : ""}
            {meta.company_name ? ` at ${meta.company_name}` : ""}
          </p>
          <div style={styles.metaRow}>
            <span style={styles.hiredBadge}>HIRED</span>
            <span style={styles.timestamp}>{formatTime(card.created_at)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

function formatTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diffHrs = (now - date) / (1000 * 60 * 60);
  if (diffHrs < 1) return "Just now";
  if (diffHrs < 24) return `${Math.floor(diffHrs)}h ago`;
  const diffDays = Math.floor(diffHrs / 24);
  if (diffDays === 1) return "1d ago";
  return `${diffDays}d ago`;
}

const styles = {
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    marginBottom: "16px",
    padding: "18px 20px",
  },
  row: {
    display: "flex",
    gap: "12px",
    alignItems: "flex-start",
  },
  iconWrap: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    backgroundColor: "#f0fdf4",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  message: {
    fontSize: "15px",
    color: "#0f172a",
    margin: "0 0 8px 0",
    lineHeight: 1.4,
  },
  metaRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  hiredBadge: {
    fontSize: "11px",
    fontWeight: "700",
    padding: "3px 10px",
    borderRadius: "5px",
    letterSpacing: "0.3px",
    backgroundColor: "#dcfce7",
    color: "#16a34a",
  },
  timestamp: {
    fontSize: "12px",
    color: "#94a3b8",
  },
};

export default PlacementConfirmedCard;
